(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Autoplay helper: try to play; if blocked (e.g., IG in-app), show the tiny play pill
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('Hero-{{ section.id }}');
    if (!root) return;

    const videos = root.querySelectorAll('video.hero__video');
    const playBtn = root.querySelector('.hero__play');

    function prep(v){
      if (!v) return;
      try {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('controlslist', 'nodownload noplaybackrate nofullscreen noremoteplayback');
      } catch(e){}
    }

    function tryAutoplay(){
      let blocked = false;
      videos.forEach(v => {
        prep(v);
        try {
          const p = v.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => { blocked = true; });
          }
        } catch(e){ blocked = true; }
      });
      // Give promises a moment to reject before deciding
      setTimeout(() => {
        if (blocked && playBtn) playBtn.style.display = 'inline-flex';
      }, 150);
    }

    tryAutoplay();

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        let played = false;
        videos.forEach(v => {
          try {
            prep(v);
            const p = v.play();
            if (p && typeof p.then === 'function') {
              p.then(() => { played = true; });
            } else {
              played = true;
            }
          } catch(e){}
        });
        if (played) playBtn.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
